"use client"

import { useState } from "react"

// Accessibility:
// https://www.w3.org/WAI/ARIA/apg/patterns/accordion/

import { NpAccordionItem, NpAccordionItemData } from "src/components/np-design/components/accordion/NpAccordionItem"

export type NpAccordionProps = {
  items: NpAccordionItemData[]
}

export const NpAccordion = ({ items }: NpAccordionProps) => {
  const [expandedItem, setExpandedItem] = useState<NpAccordionItemData | undefined>()

  return (
    <ul className="text-lg font-light">
      {items.map((item, index) => {
        return (
          <NpAccordionItem
            key={index}
            {...item}
            first={index === 0}
            last={index === items.length - 1}
            expanded={item === expandedItem}
            onToggle={() => (item === expandedItem ? setExpandedItem(undefined) : setExpandedItem(item))}
          />
        )
      })}
    </ul>
  )
}
